<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >

      <h2>WX头像上传</h2>
      <span>推荐尺寸：260x260 的方形</span>
      <el-upload
        class="avatar-uploader"
        action="/user/wxtouxianguploadfile"
        :on-success="handleAvatarSuccess"
        accept="image/jpeg"
        :data="uploaddata"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload">
        <img   :src="imageUrl" v-if="visav" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <h2>Logo上传</h2>
      <span>推荐尺寸：白底PNG最好是 透明底680x360 的长方形</span>
      <el-upload
        class="avatar-uploader"
        action="/user/wxlogopnguploadfile"
        :on-success="handleAvatarSuccess2"
        accept="image/png"
        :data="uploaddata"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload2">
        <img  :src="imageUrl4"  v-if="visav" class="avatar2" >
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
  </div>


</template>

<script>
import axios from "axios";
//http://127.0.0.1:12080
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      loading :false,
      devkindkind:0,
      size:100,
      fileList: [],
      imageUrl2:"/static/u1.jpg",
      imageUrl:"/static/u1.jpg",
      imageUrl3:"/static/logo_wx1.png",
      imageUrl4:"/static/logo_wx1.png",
      uploaddata:{},
      ms:"",
      visav:true
    };
  },
  created(){
      this.imageUrl = this.imageUrl2+"?ms="+this.ms;
      this.imageUrl4 = this.imageUrl3+"?ms="+this.ms;
  },
  methods: {
    handleAvatarSuccess2(res, file){
        console.log("handleAvatarSuccess2",res,file);
        this.imageUrl4 = this.imageUrl3+"?ms="+this.ms;
        //this.$router.go(0);
        this.visav = false;
        this.visav = true;
    },
    handleAvatarSuccess(res, file) {
        //this.dialogFormVisible = false;
        //this.get_swap_info();
        console.log("handleAvatarSuccess1",res,file);
        this.imageUrl = this.imageUrl2+"?ms="+this.ms;
        //this.$router.go(0);
        this.visav = false;
        this.visav = true;
    },
    beforeAvatarUpload2(file){
          var fileName = new Array();
          fileName = file.name.split(".");
           console.log(file);
           this.ms = file.uid;
          this.uploaddata.id =  sessionStorage.getItem("id");
          this.uploaddata.token = sessionStorage.getItem("token");//name
          this.uploaddata.name = "static/u1.png";  //file.name;
          this.uploaddata.type = "logo";
          this.uploaddata.to = "#";
          const extension =  fileName[fileName.length - 1] === "png";
          const extension2 = fileName[fileName.length - 1] === "PNG";
          if (!extension && !extension2) {
            this.$message({
              message: "上传文件只能是png格式!",
              type: "warning"
            });
            return false;
          }
            const isJPG = file.type === 'image/png';
            const isLt2M = file.size / 1024 <  500;
            if (!isJPG) {
              this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
              this.$message.error('上传头像图片大小不能超过 500KB!');
            }
            return isJPG && isLt2M;
    },
    beforeAvatarUpload(file){
          var fileName = new Array();
          fileName = file.name.split(".");
          console.log(file);
          this.ms = file.uid;
          this.uploaddata.id =  sessionStorage.getItem("id");
          this.uploaddata.token = sessionStorage.getItem("token");//name
          this.uploaddata.name = "static/u1.jpg";  //file.name;
          this.uploaddata.type = "touxiang";
          this.uploaddata.to = "#";
          const extension =  fileName[fileName.length - 1] === "jpg";
          const extension2 = fileName[fileName.length - 1] === "JPG";
          if (!extension && !extension2) {
            this.$message({
              message: "上传文件只能是jpg格式!",
              type: "warning"
            });
            return false;
          }
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 <  500;
            if (!isJPG) {
              this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
              this.$message.error('上传头像图片大小不能超过 500KB!');
            }
            return isJPG && isLt2M;
    },
    get_file_list() {
      let data = new FormData();
      data.append("username", this.input_username);
      data.append("passwd", this.input_passwd);
      axios
        .get("user", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style scoped>
#devmg {
  padding : 20px;
  width: 100%;
  text-align:left ;
}
.el-table {
  margin: 20px ;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.edit_dev  {
	text-align:left ;
	/deep/ .el-transfer-panel {
		width:300px;
	}
}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    border-radius: 50%;
    width: 178px;
    height: 178px;
    display: block;
  }
  .avatar2 {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/xxxvue/admin_device_Mg.vue